import React, { useState } from 'react';

const modules = [
    {
        id: 1,
        title: "Radio Communication Protocols",
        type: "slide",
        src: "/slides/radio-comm.pdf",
        questions: [
          {
            q: "What is the correct phrase to request landing?",
            options: ["Requesting touchdown", "Ready to drop", "Request landing clearance"],
            correct: 2
          }
        ]
      },
    {
    id: 2,
    title: "Introduction to Aviation Safety",
    type: "video",
    src: "/videos/safety-intro.mp4",
    questions: [
      {
        q: "What is the primary goal of aviation safety?",
        options: ["Reduce cost", "Prevent accidents", "Speed up flights"],
        correct: 1
      }
    ]
  },

];

const TrainingModule = () => {
  const [currentModule, setCurrentModule] = useState(0);
  const [showQuiz, setShowQuiz] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [answered, setAnswered] = useState(false);
  const [correct, setCorrect] = useState(false);

  const module = modules[currentModule];
  const question = module.questions[0];

  const handleQuizSubmit = () => {
    const isCorrect = selectedOption === question.correct;
    setCorrect(isCorrect);
    setAnswered(true);
  };

  const nextModule = () => {
    setCurrentModule((prev) => prev + 1);
    setShowQuiz(false);
    setSelectedOption(null);
    setAnswered(false);
    setCorrect(false);
  };

  return (
    <div className="max-w-2xl mx-auto p-4">
      <h2 className="text-xl font-bold mb-4">{module.title}</h2>

      {module.type === 'video' && (
        <video
          src={module.src}
          controls
          className="w-full mb-4"
          onEnded={() => setShowQuiz(true)}
        />
      )}

      {module.type === 'slide' && (
        <iframe
          src={module.src}
          title="Slide Viewer"
          className="w-full h-96 mb-4"
          onLoad={() => setShowQuiz(true)}
        ></iframe>
      )}

      {showQuiz && (
        <div className="bg-white p-4 rounded shadow">
          <p className="mb-2 font-semibold">{question.q}</p>
          {question.options.map((opt, idx) => (
            <div key={idx} className="mb-2">
              <label>
                <input
                  type="radio"
                  name="quiz"
                  value={idx}
                  checked={selectedOption === idx}
                  onChange={() => setSelectedOption(idx)}
                  className="mr-2"
                />
                {opt}
              </label>
            </div>
          ))}
          {!answered ? (
            <button
              onClick={handleQuizSubmit}
              className="mt-3 bg-blue-600 text-white px-4 py-2 rounded"
            >
              Submit Answer
            </button>
          ) : (
            <div className="mt-4">
              <p className={correct ? 'text-green-600' : 'text-red-600'}>
                {correct ? 'Correct!' : 'Incorrect, try again.'}
              </p>
              {correct && currentModule < modules.length - 1 && (
                <button
                  onClick={nextModule}
                  className="mt-3 bg-green-600 text-white px-4 py-2 rounded"
                >
                  Continue to Next Module
                </button>
              )}
              {correct && currentModule === modules.length - 1 && (
                <p className="mt-3 font-bold">You have completed all modules!</p>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default TrainingModule;
